import { render, staticRenderFns } from "./PartCreationDialog.vue?vue&type=template&id=154206b6&"
import script from "./PartCreationDialog.vue?vue&type=script&lang=js&"
export * from "./PartCreationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports